import { Link, useNavigate } from 'react-router-dom';

// Plain-text style, no design flourish, just legible. The /terms route is
// public — accessible from the sign-in screen and the in-app links on
// /age-gate, /welcome, and /settings.
export function Terms() {
  const navigate = useNavigate();
  return (
    <div className="shell" style={{ maxWidth: 680 }}>
      <header className="rise" style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
          style={{ marginBottom: 12 }}
        >
          ← Back
        </button>
        <h1 className="h1">Terms of Service</h1>
        <p className="faint" style={{ fontSize: 13, marginTop: 4 }}>Last updated: 2026-05-03</p>
      </header>

      <article className="rise" style={{ lineHeight: 1.65, fontSize: 15, color: 'var(--text)' }}>
        <p style={{ marginTop: 0 }}>By using RESLT you agree to the following.</p>

        <h2 className="h2" style={{ marginTop: 24 }}>What RESLT is</h2>
        <p>
          RESLT is an AI fitness coaching app. It tracks your check-ins (weight, steps, mood,
          training), produces analysis (weight trend, plateau detection, projected goal date),
          and generates coaching replies through OpenAI's API. It is an information and
          coaching tool. It is not medical advice. Any body-fat estimates the app produces are
          directional, not clinical. Speak to a medical professional before changing your diet
          or training in any meaningful way, especially if you have an existing health condition.
        </p>

        <h2 className="h2" style={{ marginTop: 24 }}>Who can use it</h2>
        <p>
          You must be 18 or older to use RESLT. Account creation requires you to confirm your
          date of birth. If you are under 18, your account is deleted automatically.
        </p>

        <h2 className="h2" style={{ marginTop: 24 }}>What we store</h2>
        <p>
          Your account data — profile, check-ins, chat history, and coaching memory — lives in a
          Supabase Postgres database with encryption at rest. We do not store a password;
          sign-in is via email magic link.
        </p>

        <h2 className="h2" style={{ marginTop: 24 }}>Deleting your account</h2>
        <p>
          You can permanently delete your RESLT account, including profile, check-ins, chat
          history, and coaching memory, at any time from inside the app
          (<Link to="/settings" style={{ textDecoration: 'underline' }}>Settings → Delete account</Link>).
          Deletion is immediate and irreversible.
        </p>

        <h2 className="h2" style={{ marginTop: 24 }}>Your data, your choice</h2>
        <p>
          For data requests, corrections, or any privacy questions, contact{' '}
          <a href="mailto:jamesfield31@gmail.com" style={{ textDecoration: 'underline' }}>
            jamesfield31@gmail.com
          </a>.
        </p>

        <h2 className="h2" style={{ marginTop: 24 }}>Changes</h2>
        <p>We may update these terms. Material changes will be communicated through the app.</p>
      </article>
    </div>
  );
}
